import * as React from "react";
import {Component} from "react";
import styles from "../../../styles/flyouts/superadmin/raw_materials/Properties.scss";
import * as _ from "lodash";
import {withRouter} from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import {setNotification} from "../../../redux/actions/general/notification";
import {listRawMaterials, updateRawMaterial} from "../../../redux/actions/table/superadmin/raw_materials";
import EditRawMaterialForm from "../../../forms/superadmin/raw_materials/EditRawMaterialForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateRawMaterial(formData.id, _.omit(formData, ['id'])).then(() => {
                listRawMaterials();

                this.props.readAction(formData.id);

                setNotification(__('properties.notifications.properties-have-been-saved'));
            })
        );
    }

    render() {
        const {data} = this.props;

        return (
            <div className={styles.scroller}>
                <EditRawMaterialForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'priority', 'name']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
